// store/notificationStore.js
import { create } from 'zustand'

export const useNotificationStore = create((set) => ({
  notifications: [],
  addNotification: (notification) => {
    const id = Math.random().toString(36).substring(2, 9)
  
    // 💡 Set default duration to 5000ms if not provided AND not manual
    const duration = notification.duration === undefined && !notification.action ? 5000 : notification.duration
  
    const newNotification = { ...notification, id, duration }
  
    set((state) => ({
      notifications: [...state.notifications, newNotification],
    }))
  
    if (duration !== undefined) {
      setTimeout(() => {
        set((state) => ({
          notifications: state.notifications.filter((n) => n.id !== id),
        }))
      }, duration)
    }
  },
  removeNotification: (id) =>
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id),
    })),
}))
